// LiveKit Cloud
export const LIVEKIT_URL = process.env.REACT_APP_LIVEKIT_URL || "wss://mina-ng3lfcax.livekit.cloud";

// Token endpoint (Cloudflare Pages Function)
export const TOKEN_ENDPOINT = "/api/livekit-token";

// Voice notes worker
export const VOICE_NOTES_WORKER_URL =
  process.env.REACT_APP_VOICE_NOTES_WORKER_URL ||
  "https://mina-voice-notes-mcp.boris-8d0.workers.dev";

export const UPLOAD_SECRET = "mina-family";

export const NOTIFICATION_WS_URL = `${VOICE_NOTES_WORKER_URL.replace("https://", "wss://")}/subscribe`;
